const localStorageUtil = {
  /**
   * 设置值到localStorage
   * @param {*} key
   * @param {*} value
   * @param {*} expires 有效时间（单位秒）,没有时间限制的话不传
   */
  set(key, value, expires) {
    var storage = {}
    if (expires) {
      storage._time_size = expires * 1000
      storage._expires = new Date().getTime() + expires * 1000
    }
    storage._value = value
    localStorage.removeItem(key)
    try {
      localStorage.setItem(key, JSON.stringify(storage))
    } catch (oException) {
      if (oException.name == 'QuotaExceededError') {
        console.log('error:超出本地存储限额！')
      }
    }
  },

  /**
   * 判断是否过期,过期为true
   * 没有值也认为是过期
   */
  isExpire(key) {
    var isExpire = true,
      storage = localStorage.getItem(key),
      now = new Date().getTime()

    if (storage) {
      storage = JSON.parse(storage)
      if (storage._expires) {
        // 当前时间是否大于过期时间
        isExpire = now > storage._expires
      } else {
        isExpire = false
      }
    } else {
      // 没有值也是过期
    }
    return isExpire
  },

  /**
   * 获取localStorage中的值
   * 返回为null代表过期或是没有值
   * @param {*} key
   */
  get(key) {
    var isExpire = this.isExpire(key),
      value = null
    if (!isExpire) {
      value = localStorage.getItem(key)
      value = JSON.parse(value)
      value = value._value
    } else {
      localStorage.removeItem(key)
    }
    return value
  },

  /**
   * 清除指定key
   * @param {*} key
   */
  remove(key) {
    localStorage.removeItem(key)
  },

  /**
   * 清除所有
   */
  clear() {
    localStorage.clear()
  }
}

export default localStorageUtil



// WEBPACK FOOTER //
// ./src/api/localStorageUtil.js